import { render, staticRenderFns } from "./riskCheckRule.vue?vue&type=template&id=01503ac6&scoped=true"
import script from "./riskCheckRule.vue?vue&type=script&lang=js"
export * from "./riskCheckRule.vue?vue&type=script&lang=js"
import style0 from "./riskCheckRule.vue?vue&type=style&index=0&id=01503ac6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01503ac6",
  null
  
)

export default component.exports